// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__32CMp","paymentContainer":"PaymentPage_paymentContainer__IuLSe"};